import React, { useState, useEffect } from "react";
import Header from "../Header/Header";
import Cards from "../cards/Cards";
import "./Home.css";
import { getAllProducts, allProducts } from "../redux/reducer/products";
import { useDispatch, useSelector } from "react-redux";

const Home = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(true);
  let products = useSelector(allProducts);
  useEffect(() => {
    dispatch(getAllProducts()).then(() => setIsLoading(false));
  }, [dispatch, setIsLoading]);
  console.log(products);
  return (
    <>
      <Header />
      <section className="content">
        {!isLoading
          ? products.map((pr, index) => (
              <Cards
                name={pr.name}
                image={pr.image_url[0]}
                key={index}
                price={pr.price}
              />
            ))
          : "Cargando..."}
      </section>
    </>
  );
};

export default Home;
